import { $applyNodeReplacement } from "lexical";
import { QuoteNode } from "./QuoteNode.js";
function $createQuoteNode(text, author) {
    return $applyNodeReplacement(new QuoteNode(text, author));
}
function $isQuoteNode(node) {
    return node instanceof QuoteNode;
}
export { $createQuoteNode, $isQuoteNode };
